
























import { Vue, Component } from "vue-property-decorator";
import { vxm } from "@/store";

@Component({
  created() {
    this.$vuetify.theme.dark = true;
  },

  destroyed() {
    this.$vuetify.theme.dark = vxm.app.dark;
  }
})
export default class Slideshow extends Vue {
  get game() {
    return vxm.results.game;
  }

  get media() {
    return vxm.results.media;
  }

  get medium() {
    return vxm.results.media[0];
  }

  get teams() {
    return vxm.results.teams;
  }
}
